import { BaseHead, CellOfRow } from '@components/tables';
import { Skeleton, Stack, Table, TableBody, TableHead, TableRow } from '@mui/material';
import color from '@theme/Colors';

interface SkeletonCellProps {
    width: number;
}

interface SkeletonTableProps {
    rows: number;
    columns: number;
    skeletonWidths: number[];
    nestedSkeletonWidths?: number[];
}

const SkeletonCell: React.FC<SkeletonCellProps> = ({ width }) => (
    <Skeleton sx={{ bgcolor: color.grey200, borderRadius: '4px' }} variant="text" animation="pulse" width={width} />
);

const SkeletonEventLogTable: React.FC<SkeletonTableProps> = ({
    rows,
    columns,
    skeletonWidths,
    nestedSkeletonWidths,
}) => {
    return (
        <Table aria-label="simple table">
            <TableHead>
                <TableRow>
                    {[...Array(columns)].map((_, colIndex) => (
                        <BaseHead
                            align="left"
                            title={<SkeletonCell width={skeletonWidths[colIndex]} />}
                            isLeftLabel
                            sx={{
                                justifyContent: 'flex-start',
                                alignItems: 'start',
                            }}
                        />
                    ))}
                </TableRow>
            </TableHead>

            <TableBody>
                {[...Array(rows)].map((_, rowIndex) => (
                    <TableRow key={`row-${rowIndex}`}>
                        {[...Array(columns)].map((_, colIndex) => (
                            <CellOfRow
                                key={`cell-${rowIndex}-${colIndex}`}
                                value={
                                    <Stack>
                                        {colIndex === columns - 1 && nestedSkeletonWidths ? (
                                            <ul style={{ margin: '4px 0' }}>
                                                <li>
                                                    <SkeletonCell width={skeletonWidths[colIndex]} />
                                                </li>
                                                <ul style={{ margin: '4px 0' }}>
                                                    {nestedSkeletonWidths.map((width, nestedIndex) => (
                                                        <li key={`nested-${nestedIndex}`}>
                                                            <SkeletonCell width={width} />
                                                        </li>
                                                    ))}
                                                </ul>
                                            </ul>
                                        ) : (
                                            <SkeletonCell width={skeletonWidths[colIndex]} />
                                        )}
                                    </Stack>
                                }
                                align="left"
                            />
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default SkeletonEventLogTable;
